// ============================================================================
// KPI row — four vivid Pulse StatTiles with big animated count-up numbers.
// Reads the live, API-backed KPIs from the dashboard data context.
// ============================================================================
import { useTranslation } from "react-i18next";
import { StatTile } from "../components";
import { IconBellAlert, IconCalendar, IconClock, IconUsers } from "../components/icons";
import { useDashboardCtx } from "./DashboardDataContext";

export function KpiRow() {
  const { t } = useTranslation();
  const { kpis } = useDashboardCtx();
  return (
    <section aria-label={t("dashboard.kicker")} className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">
      <StatTile
        label={t("kpi.activeClients")}
        value={kpis.activeClients}
        accent="coral"
        icon={<IconUsers />}
        delta={kpis.deltas.activeClients}
        deltaTone="up"
      />
      <StatTile
        label={t("kpi.sessionsThisWeek")}
        value={kpis.sessionsThisWeek}
        accent="violet"
        icon={<IconCalendar />}
        delta={kpis.deltas.sessionsThisWeek}
        deltaTone="up"
      />
      <StatTile
        label={t("kpi.hoursThisWeek")}
        value={kpis.hoursThisWeek}
        decimals={1}
        suffix="h"
        accent="ocean"
        icon={<IconClock />}
        delta={kpis.deltas.hoursThisWeek}
        deltaTone="up"
      />
      <StatTile
        label={t("kpi.dueToSchedule")}
        value={kpis.dueToSchedule}
        accent="lime"
        icon={<IconBellAlert />}
        delta={
          kpis.dueToSchedule > 0 ? t("kpi.needsAction") : t("kpi.allBooked")
        }
        deltaTone={kpis.dueToSchedule > 0 ? "down" : "flat"}
      />
    </section>
  );
}
